/** Outward expansion at low zoom so tiny bboxes stay visible without a halo-creating stroke. */
export const LOW_ZOOM_INFLATE_PX = 3;

/** On-screen border thickness in pixels when the plan is zoomed all the way in. Below max zoom the stroke scales down proportionally (real-world perspective). */
export const BBOX_STROKE_PX = 4;

/** Same idea for the selected bbox; kept bolder so the selection stands out. */
export const SELECTED_BBOX_STROKE_PX = 6.5;

/** Fraction of threshold zoom where low-zoom inflation starts ramping down. */
export const INFLATE_RAMP_START_FRACTION = 0.5;

/** Discrete inflation buckets across the low-zoom range; prevents path-string churn on every zoom tick. */
export const ZOOM_QUANTUM_DIVISOR = 8;
